import {FC} from 'react'
import {
  FORM_CONTAINER_PADDING,
  FORM_CONTAINER_PADDING_MOBILE,
  FORM_CONTAINER_WIDTH,
} from 'theme/sizing'

import {MOBILE_SCREENSIZE, USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

export const FormContainer: FC<React.PropsWithChildren<unknown>> = ({children}) => (
  <>
    <div className="container">{children}</div>

    <style jsx>{`
      .container {
        width: 100%;
        max-width: calc(${FORM_CONTAINER_WIDTH} + ${FORM_CONTAINER_PADDING} * 2);
        padding: 0 ${FORM_CONTAINER_PADDING};
        margin: 0 auto;
      }
      @media ${USER_TABLET_SCREENSIZE} {
        .container {
          max-width: inherit;
        }
      }
      @media ${MOBILE_SCREENSIZE} {
        .container {
          padding: 0 ${FORM_CONTAINER_PADDING_MOBILE};
        }
      }
    `}</style>
  </>
)
